import {Stack, Text} from '@chakra-ui/react';
import React, {FC} from 'react';
import {dictionary} from 'translations';

import {Checkbox} from '../checkbox';

interface IProps {
  language?: string;
  locales?: string[];
  onChange: (item: string) => void;
}

export const CheckboxLanguage: FC<IProps> = React.memo(({language, locales, onChange}) => {
  if (!locales?.length) return null;
  return (
    <Stack direction="column" alignItems="flex-start">
      {locales &&
        locales.map((item) => (
          <Checkbox key={item} variant="circle" onChange={() => onChange(item)} p={0} isChecked={language === item}>
            <Text as="span" fontSize={['14px', '18px']} fontWeight={500}>
              {dictionary[item]['LANG']}
            </Text>
          </Checkbox>
        ))}
    </Stack>
  );
});
